import { useLingui } from '@lingui/react/macro'
import { useEffect } from 'react'
import * as z from 'zod/v4'

export const useSetErrorMap = () => {
	const { t } = useLingui()

	useEffect(() => {
		z.config({
			customError: (issue) => {
				const field = issue.path?.join('.')
				const input = JSON.stringify(issue.input)
				const code =
					issue.code === 'custom' ? issue.params?.customCode : issue.code

				const ref: Record<string, () => string> = {
					default: () => t`Champ invalide`,

					// Global errors
					invalid_string: () => t`Format invalide`,
					invalidDate: () => t`Date invalide`,
					invalidEmail: () => t`Cet email est invalide`,
					invalidForm: () =>
						t`Le formulaire est incomplet ou contient des erreurs`,
					invalidFormat: () => t`Format invalide`,
					max: () => t`Maximum ${input}`,
					maxLength: () => t`Longueur maximum ${input}`,
					min: () => t`Minimum ${input}`,
					required: () => t`Ce champ est obligatoire`,
					too_small: () => t`Ce champ est obligatoire`,

					// Custom errors
					cardIncomplete: () => t`Informations incomplètes`,
					cgv: () => t`Vous devez accepter les conditions de vente`,
					endTimeMustBeHigherThanStartTime: () =>
						t`L'heure de fin doit être supérieure à l'heure de début`,
					passwordConfirm: () =>
						t`Votre saisie ne correspond pas au nouveau mot de passe`,
					passwordMinLength: () =>
						t`Votre nouveau mot de passe doit être supérieur à 6 caractères`,

					// Fields specific errors
					'password.lowercase': () =>
						t`Votre mot de passe doit comporter au une lettre minuscule`,
					'password.minLength': () =>
						t`Votre mot de passe doit comporter au moins 8 caractères`,
					'password.mismatch': () => t`Les mots de passe ne correspondent pas`,
					'password.number': () =>
						t`Votre mot de passe doit comporter au moins un chiffre`,
					'password.specialCharacters': () =>
						t`Votre mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule et un chiffre`,
					'password.too_small': () =>
						t`Votre mot de passe doit comporter au moins 6 caractères`,
					'password.uppercase': () =>
						t`Votre mot de passe doit comporter au une lettre majuscule`,
				}

				return {
					message:
						ref[code]?.() ||
						ref[`${field}.${issue.code}`]?.() ||
						issue.message ||
						ref.default(),
				}
			},
		})
	}, [t])
}
